import React from 'react';
import { StyleSheet, View } from 'react-native';

const styles = StyleSheet.create({
  separator: {
    backgroundColor: '#ddd',
  },
});

interface SeparatorProps {
  crossAxisMargin?: number;
  direction?: string;
  noMargin?: boolean;
  thickness?: number;
}

export const Separator = ({
  crossAxisMargin = 0,
  direction = 'horizontal',
  noMargin = false,
  thickness = 1,
}: SeparatorProps): React.JSX.Element=> {
  const margin = !noMargin ? 11 : 0;
  const style =
    direction === 'horizontal'
      ? {
          marginHorizontal: margin,
          marginVertical: crossAxisMargin,
          height: thickness,
        }
      : {
          marginVertical: margin,
          marginHorizontal: crossAxisMargin,
          width: thickness,
        };
  return <View style={[styles.separator, style]} />;
};
